import { Avatar } from '@pocketlaw/tetris';
import { SearchEntityIcon } from 'app/domains/global-search/components/SearchEntityIcon';
export function EntityIcon(props) {
    const { type } = props;
    return (<Avatar appearance="light" size="sm">
      <SearchEntityIcon type={type}/>
    </Avatar>);
}
